import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'

import LogoMark from 'static/images/Logo-R4R-Mark-Navy.png'
import BoxWithSafeZone from 'components/BoxWithSafeZone'
import theme from 'styles/theme'

// Auth shell for login / reset / new password ("Panel Klienta 3.0" look — no dedicated Figma screen).
const Auth = () => {
  return (
    <BoxWithSafeZone
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: '16px',
        py: '32px',
        background: theme.r4r.gradient,
        position: 'relative',
        overflow: 'hidden',
        // Soft atmospheric shapes — keep brand navy/azure, no flat fill.
        '::before': {
          content: '""',
          position: 'absolute',
          width: '480px',
          height: '480px',
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.06)',
          top: '-120px',
          right: '-80px',
          pointerEvents: 'none'
        },
        '::after': {
          content: '""',
          position: 'absolute',
          width: '360px',
          height: '360px',
          borderRadius: '50%',
          background: 'rgba(36, 212, 225, 0.12)',
          bottom: '-80px',
          left: '-60px',
          pointerEvents: 'none'
        }
      }}>
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          width: '100%',
          maxWidth: '420px',
          backgroundColor: '#fff',
          boxShadow: theme.r4r.heroShadow,
          px: { xs: '24px', sm: '36px' },
          pt: '36px',
          pb: '28px'
        }}>
        <Box sx={{ textAlign: 'center', mb: '28px' }}>
          <Box
            component='img'
            src={LogoMark}
            alt='Resi4Rent'
            sx={{ height: '96px', width: 'auto' }}
          />
        </Box>
        <Outlet />
      </Box>
    </BoxWithSafeZone>
  )
}

export default Auth
